import * as React from 'react';
import Header from '../Header/HeaderWrapper';

const Layout = ({children, contentfulLocale}) => {
    return (
        <div className="global-wrapper">
            <Header locale={contentfulLocale} />
            <main className="main">{children}</main>
        </div>
    );
};

export default Layout;
